import React from "react";
import ContextMenuZindex from "../../components/zIndexContextMenu";
import PasteContextMenuZindex from "../../components/PasteContextmenu";
import { useEditorMainPageContext } from "../contexts/EditorMainPageContext";

export const EditorCanvasContextMenus = () => {
  const ctx = useEditorMainPageContext();
  const {
    setZindexDelete,
    contextMenuRef,
    updateZindexValue,
    selectedComponent,
    deleteComponentOnCanvas,
    handleDeleteKeyScrollbarComponent,
    editComponentRef,
    editComponent,
    layerCompData,
    scrollbarItems,
    isVisible,
    setVisibility,
    copiedComponent,
    copyCanvasComponent,
    pasteComponentOnCanvas,
    setShowPaste,
    toggleLockComp,
    toggleHideComp,
    playPause,
    multiSelectedComps,
    componentType,
    imageOnCanvas,
    showPaste,
  } = ctx;

  return (
    <>
      <ContextMenuZindex
        setZindexDelete={setZindexDelete}
        outerRef={contextMenuRef}
        updateZindexValue={updateZindexValue}
        selectedComponent={selectedComponent}
        deleteComponentOnCanvas={deleteComponentOnCanvas}
        handleDeleteKeyScrollbarComponent={handleDeleteKeyScrollbarComponent}
        editComponentRef={editComponentRef}
        layerCompData={!editComponent ? layerCompData : scrollbarItems}
        isVisible={isVisible}
        setVisibility={setVisibility}
        copiedComponent={copiedComponent}
        copyCanvasComponent={copyCanvasComponent}
        pasteComponentOnCanvas={pasteComponentOnCanvas}
        setShowPaste={setShowPaste}
        toggleLockComp={toggleLockComp}
        toggleHideComp={toggleHideComp}
        playPause={playPause}
        multiSelectedComps={multiSelectedComps}
        mm={componentType}
        imageOnCanvas={imageOnCanvas}
      />
      {copiedComponent && (
        <PasteContextMenuZindex
          outerRefPaste={contextMenuRef}
          selectedComponent={selectedComponent}
          layerCompData={layerCompData}
          showPaste={showPaste}
          setShowPaste={setShowPaste}
          pasteComponentOnCanvas={pasteComponentOnCanvas}
          setVisibility={setVisibility}
          mm={componentType}
          imageOnCanvas={imageOnCanvas}
        />
      )}
    </>
  );
};
